import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import styled from 'styled-components';
import moment from 'moment';

import SelectedDateContext from './context/SelectedDateContext';
import CalendarAvailabilityContext from './context/CalendarAvailabilityContext';
import PriceDetailsContext from './context/PriceDetailsContext';
import ListingContext from './context/ListingContext';

type Props = {
  children?: any;
};

function AppContainer({ children }: Props) {
  const [selectedDateRange, setSelectedDateRange] = useState<{
    start: any | null;
    end: any | null;
  }>({
    start: null,
    end: null
  });

  const element = document.getElementById('react-root');
  /* @ts-ignore */
  const listingId = element.getAttribute('data-listing-id');

  const {
    isPending: isCalendarPending,
    isError: isCalendarError,
    data: calendarData,
    error: calendarError
  } = useQuery({
    queryKey: ['todos'],
    staleTime: 300000, // 5 mins
    queryFn: async () => {
      const response = await fetch(
        `https://booking-engine.hostaway.com/bookingEngines/book.hideout.house/listings/${listingId}/calendar?startingDate=2024-04-24`
      );
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      return response.json();
    }
  });

  const {
    isPending: isPriceDetailsPending,
    isError: isPriceDetailsError,
    data: priceDetailsData,
    error: priceDetailsError
  } = useQuery({
    queryKey: ['priceDetails', selectedDateRange],
    // staleTime: 0,
    queryFn: async () => {
      const params = {
        startingDate: moment(selectedDateRange.start).format('YYYY-MM-DD'),
        endingDate: moment(selectedDateRange.end).format('YYYY-MM-DD'),
        numberOfGuests: 2,
        reservationCouponId: null,
        version: '2',
        components: []
      };
      const response = await fetch(
        `https://booking-engine.hostaway.com/bookingEngines/book.hideout.house/listings/${listingId}/calendar/priceDetails`,
        {
          method: 'POST',
          body: JSON.stringify(params)
        }
      );
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    },
    enabled: !!selectedDateRange.start && !!selectedDateRange.end
  });

  return (
    <SelectedDateContext.Provider value={{ selectedDateRange, setSelectedDateRange }}>
      <CalendarAvailabilityContext.Provider
        value={{ isCalendarPending, isCalendarError, calendarData, calendarError }}>
        <PriceDetailsContext.Provider
          value={{
            isPriceDetailsPending,
            isPriceDetailsError,
            priceDetailsData,
            priceDetailsError
          }}>
          <ListingContext.Provider
            value={{
              listingId
            }}>
            <AppWrapper>{children}</AppWrapper>
          </ListingContext.Provider>
        </PriceDetailsContext.Provider>
      </CalendarAvailabilityContext.Provider>
    </SelectedDateContext.Provider>
  );
}

export default AppContainer;

const AppWrapper = styled.div`
  font-family: 'Satoshi';
`;
